import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'page_view',
          page_path: location.pathname,
          page_location: window.location.href,
          page_title: document.title,
        });
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export default RouteChangeTracker;